/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally

==========================================================================================*/


import Vue from 'vue'
import VxTooltip from './layouts/components/vx-tooltip/VxTooltip.vue'
import VxCard  from './components/vx-card/VxCard.vue'
import VxCardCustom  from './components/vx-card/VxCardCustom.vue'
import VxList  from './components/vx-list/VxList.vue'
import VxBreadcrumb  from './layouts/components/VxBreadcrumb.vue'
import FeatherIcon  from './components/FeatherIcon.vue'
import VxInputGroup  from './components/vx-input-group/VxInputGroup.vue'
import FileUploader  from './components/shared/FileUploader.vue'
import FileUploaderNotRequired  from './components/shared/FileUploaderNotRequired.vue'
import MultiFileUploader from "@/components/shared/MultiFileUploader";
import VxReadMore from "@/components/vx-read-more/VxReadMore";

Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxCardCustom.name, VxCardCustom)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component(FileUploader.name, FileUploader)
Vue.component(FileUploaderNotRequired.name, FileUploaderNotRequired)
Vue.component(MultiFileUploader.name, MultiFileUploader)
Vue.component(VxReadMore.name, VxReadMore)


// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'XIcon',
        svgClasses: 'w-4 h-4 mt-1'
      }
    })
  },
  OpenIndicator: {
    render: createElement => createElement('feather-icon', {
      props: {
        icon: 'ChevronDownIcon',
        svgClasses: 'w-5 h-5'
      }
    })
  }
})

Vue.component(vSelect)
